module.exports = __webpack_public_path__ + "4be466d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon-supplies-moving@2x.png
// module id = 1054
// module chunks = 0